import { c as _c } from "react/compiler-runtime";
import { Avatar } from '@morpho-org/ui-v6/client';
import { Badge } from '@repo/ui';
import { memo } from 'react';
import { MobileCardRow } from '@/components/common/MobileCardRow';
interface MobileAmountRowProps {
  label: string;
  logoURI: string | null;
  amount: string | null | undefined;
  usdValue: string | null | undefined;
}
const MobileAmountRow = t0 => {
  const $ = _c(15);
  const {
    label,
    logoURI,
    amount,
    usdValue
  } = t0;
  let t1;
  if ($[0] !== logoURI) {
    t1 = logoURI && <Avatar size="small" src={logoURI} />;
    $[0] = logoURI;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      lineHeight: "normal"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== amount) {
    t3 = <span className="text-3xs text-foreground" style={t2}>{amount}</span>;
    $[3] = amount;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== amount || $[6] !== usdValue) {
    t4 = amount && usdValue && <Badge variant="tertiary" size="sm" className="my-auto">{usdValue}</Badge>;
    $[5] = amount;
    $[6] = usdValue;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t3 || $[10] !== t4) {
    t5 = <div className="gap-2xs flex items-center">{t1}{t3}{t4}</div>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== label || $[13] !== t5) {
    t6 = <MobileCardRow label={label}>{t5}</MobileCardRow>;
    $[12] = label;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
export default memo(MobileAmountRow);